import loadable from '@loadable/component'
import { useLocation } from 'react-router'

import TripGuard from './components/TripGuard/TripGuard'
import RootWrapper from './pages/RootWrapper'
import Trip404Page from './pages/Trip404Page'
import type { TripTab } from './utils/tabs'
import TripTabRedirect from './pages/TripTabRedirect'
import Redirect from './components/Redirect'

import AuthRoute from 'components/App/Routes/AuthRoute'

import { CHAT_TRIP_PLANNER_NEW_PATH } from 'tripPlanner/config'
import WebViewRoutes from 'tripPlanner/pages/WebViews/WebViewRoutes'
import { LocaleAwareSwitch } from 'components/App/Routes/LocaleAwareRoute'
import TrackedRoute from 'components/App/Routes/TrackedRoute'

const PublicTripParent = loadable(
  () =>
    import(
      'tripPlanner/pages/publicTrip/PublicTripParent'
    ),
)

const TripPlannerAboutPage = loadable(
  () =>
    import(
      'tripPlanner/pages/about/TripPlannerAboutPage'
    ),
)

const ChatTripPlannerPage = loadable(
  () =>
    import(
      'tripPlanner/pages/chat/ChatTripPlannerPage'
    ),
)

const TripParent = loadable(
  () =>
    import(
      'tripPlanner/pages/trip/TripParent'
    ),
)

const AcceptInvite = loadable(
  () =>
    import(
      './pages/trip/AcceptInvite'
    ),
)

const HiddenSettings = loadable(
  () =>
    import(
      './pages/hiddenSettings/HiddenSettings'
    ),
)

const TripPlannerLandingRoute = loadable(
  () =>
    import(
      'tripPlanner/pages/trip/TripPlannerLandingRoute'
    ),
)

const tabs: Array<Lowercase<TripTab>> = ['summary', 'itinerary', 'explore', 'documents']

function GenerateTripRedirect() {
  const { search } = useLocation()
  return <Redirect to={`${CHAT_TRIP_PLANNER_NEW_PATH}${search}`} />
}

function TripPlannerRoutes() {
  return (
    <TripGuard fallback={<Trip404Page />}>
      <RootWrapper>
        <LocaleAwareSwitch>
          <TrackedRoute
            exact
            path="/:regionCode/trip-planner/about"
            component={TripPlannerAboutPage}
          />
          <TrackedRoute
            exact
            path="/:regionCode/trip-planner"
            component={TripPlannerLandingRoute}
          />
          <TrackedRoute
            exact
            path="/:regionCode/trip-planner/generate-trip"
            component={GenerateTripRedirect}
          />
          <TrackedRoute
            exact
            path="/:regionCode/trip-planner/chat-trip-planner/:chatId?"
            component={ChatTripPlannerPage}
          />
          <AuthRoute
            showPopup
            exact
            path={`/:regionCode/trip-planner/trip/:tripId/:tab(${tabs.join('|')})`}
            component={TripParent}
          />
          <TrackedRoute
            exact
            path="/:regionCode/trip-planner/public-trip/:tripId/:tab(summary|itinerary)"
            component={PublicTripParent}
          />
          <AuthRoute
            showPopup
            exact
            path="/:regionCode/trip-planner/trip/:tripId/accept-invite/:inviteId"
            component={AcceptInvite}
          />
          <AuthRoute
            showPopup
            exact
            path="/:regionCode/trip-planner/hidden-settings"
            component={HiddenSettings}
          />
          <TrackedRoute path="/:regionCode/trip-planner/webView">
            <WebViewRoutes />
          </TrackedRoute>
          <TrackedRoute
            exact
            path="/:regionCode/trip-planner/trip/:tripId"
            component={TripTabRedirect}
          />
          <Trip404Page />
        </LocaleAwareSwitch>
      </RootWrapper>
    </TripGuard>
  )
}

export default TripPlannerRoutes
